import styled from 'styled-components';
import { cssHelpers } from '~helpers';
var SwitchInput = styled.input.withConfig({
  displayName: "SwitchInput",
  componentId: "bpmmny-0"
})(["", ""], cssHelpers.hiddenInput);
export default SwitchInput;